import { type AnnouncementItemDTO } from '@model/announcement/AnnouncementItemDTO';
import { toSingleLineText } from '@util/string.util';
import { useState } from 'react';

export const TEXT_TO_SPEECH_MAX_LENGTH = 500;

interface UseAnnouncementTextToSpeechProps {
  existingItem: AnnouncementItemDTO | undefined;
  onDirty: () => void;
}

interface UseAnnouncementTextToSpeechResult {
  textToSpeech: string;
  onTextToSpeechChange: (value: string) => void;
}

export const useAnnouncementTextToSpeech = ({
  existingItem,
  onDirty,
}: UseAnnouncementTextToSpeechProps): UseAnnouncementTextToSpeechResult => {
  const [textToSpeech, setTextToSpeech] = useState(() =>
    toSingleLineText(existingItem?.textToSpeech ?? '').slice(
      0,
      TEXT_TO_SPEECH_MAX_LENGTH,
    ),
  );

  const onTextToSpeechChange = (value: string) => {
    setTextToSpeech(value.slice(0, TEXT_TO_SPEECH_MAX_LENGTH));
    onDirty();
  };

  return { textToSpeech, onTextToSpeechChange };
};
